import { useEffect, useRef, useState } from 'react';
import { PageHead } from 'ui/kit/PageHead';
import { useLocation, useNavigate } from 'react-router';
import { SearchX } from 'lucide-react';
import { CabinetButton, EmptyState } from 'ui/kit/Kit';
import kit from 'ui/kit/kit.module.scss';
import screen from '../StudentTaskScreen.module.scss';

import { Button } from 'ui';

import type { TutorSearchItem } from 'api/v1/requests/bulletins';

import avatar from './../../../assets/images/people.png';
import styles from './DetailsProfile.module.scss';
import { Overlay } from '../../../ui/Overlay/Overlay';
import { HeaderDetailsProfile, InfoSection, ReviewsItem } from '../Components';
import { DetailsMenuSlot } from 'modules/Details/DetailsMenu/DetailsMenu';

export const profileData = {
  user: {
    fullName: 'Имя Фамилия Отчество',
    age: 45,
    gender: 'Женщина',
    price: '1 800 ₽/hour',
    avatar: avatar,
    about: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.
Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
Ut enim ad minim veniam: quis nostrud exercitation ullamco laboris
nisi ut aliquip ex ea commodo consequat duis aute irure dolor in reprehenderit
in voluptate velit esse cillum dolore eu fugiat nulla pariatur.`,
    education: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.
Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
Ut enim ad minim veniam: quis nostrud exercitation ullamco laboris
nisi ut aliquip ex ea commodo consequat duis aute irure dolor in reprehenderit
in voluptate velit esse cillum dolore eu fugiat nulla pariatur.`,
    place: 'Москва, площадь Революции',
  },
  reviews: [
    {
      name: 'Иван',
      date: '12.08.2025',
      items: ['Оплата вовремя', 'Оплата вовремя'],
    },
    {
      name: 'Иван',
      date: '12.08.2025',
      items: ['Оплата вовремя', 'Оплата вовремя'],
    },
    {
      name: 'Иван',
      date: '12.08.2025',
      items: ['Оплата вовремя', 'Оплата вовремя'],
    },
  ],
};

const DetailsProfileContent = () => {
  const location = useLocation();
  const item = location.state as {
    title: string;
    price: string;
    tutor?: TutorSearchItem;
  } | null;

  const [clicked, setClicked] = useState(false);
  const [showOverlay, setShowOverlay] = useState(true);
  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = listRef.current;
    if (!el) return;
    const onScroll = () => {
      const bottomReached = el.scrollHeight - el.scrollTop - el.clientHeight < 10;
      setShowOverlay(!bottomReached);
    };
    el.addEventListener('scroll', onScroll);
    return () => el.removeEventListener('scroll', onScroll);
  }, []);

  if (!item) return <p>Объявление не найдено</p>;

  const { user, reviews } = profileData;
  const t = item.tutor;
  const headerAvatar = t?.profile_avatar_url || user.avatar;
  const headerName = (t?.name && t.name.trim()) || user.fullName;
  const headerPrice = item.price || user.price;

  return (
    <main
      className={styles['profile-card__item']}
      onClick={() => setClicked(true)}
      ref={listRef}
    >
      <HeaderDetailsProfile
        avatar={headerAvatar}
        fullName={headerName}
        age={user.age}
        gender={user.gender}
        price={headerPrice}
      />

      <hr />
      <InfoSection title='О себе' text={t?.description?.trim() || user.about} />
      <hr />
      <InfoSection title='Образование' text={user.education} />
      <hr />
      <InfoSection title='Место проведения занятий' text={`Очно: ${user.place}`} />
      <hr />

      <ReviewsItem reviews={reviews} avatar={user.avatar} />

      <Button
        variant='filled'
        color='primary'
        size='lg'
        shape='brick'
        className={styles['button']}
      >
        Предложить
      </Button>

      {!clicked && <Overlay showOverlay={showOverlay} />}
    </main>
  );
};

/* Прямой переход без данных карточки: пустое состояние Figma 54:12266 вместо голой строки на белом листе. */
const DetailsProfileMissing = () => {
  const navigate = useNavigate();
  return (
    <main className={screen.page}>
      <PageHead crumb={<>Личный кабинет / Мои задачи</>} title={<>Анкета репетитора</>} />
      <DetailsMenuSlot />
      <EmptyState
        title='Анкета не найдена'
        fact='Откройте анкету из списка репетиторов по задаче: ссылка могла устареть или задача уже закрыта.'
        action={<CabinetButton onClick={() => navigate('/profile/tasks')}>К моим задачам</CabinetButton>}
      >
        <span className={kit.emptyArt} aria-hidden>
          <SearchX size={48} strokeWidth={1.5} />
        </span>
      </EmptyState>
    </main>
  );
};

export const DetailsProfile = () => {
  const location = useLocation();
  if (!location.state) return <DetailsProfileMissing />;
  return (
    <div className={styles['profile-card-wrapper']}>
      <DetailsProfileContent />
    </div>
  );
};
